import "core-js/modules/es6.reflect.construct.js";
import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _createClass from "@babel/runtime/helpers/createClass";
import _assertThisInitialized from "@babel/runtime/helpers/assertThisInitialized";
import _inherits from "@babel/runtime/helpers/inherits";
import _possibleConstructorReturn from "@babel/runtime/helpers/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/getPrototypeOf";
import _defineProperty from "@babel/runtime/helpers/defineProperty";
import "core-js/modules/es6.array.map.js";

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

/**
 * 过滤行功能内的下拉条件
 */
import React, { Component } from 'react';
import PropTypes from 'prop-types';
import Dropdown from '../../wui-dropdown/src';
import Menu from '../../wui-menu/src';
import Button from '../../wui-button/src';
import Icon from '../../wui-icon/src';
import i18n from './lib/i18n';
import { getComponentLocale } from '../../wui-locale/src/tool';
import { prefix } from "../../wui-core/src/index.js";
var Item = Menu.Item;

var FilterDropDown = /*#__PURE__*/function (_Component) {
  _inherits(FilterDropDown, _Component);

  var _super = _createSuper(FilterDropDown);

  function FilterDropDown() {
    var _this;

    _classCallCheck(this, FilterDropDown);

    _this = _super.call(this);

    _defineProperty(_assertThisInitialized(_this), "onSelectDropdown", function (item) {
      var _this$props = _this.props,
          onSelectDropdown = _this$props.onSelectDropdown,
          filterDropdownType = _this$props.filterDropdownType;

      if (onSelectDropdown) {
        if (filterDropdownType == 'string') {
          _this.setState({
            selectValue: [item.key]
          }, function () {
            onSelectDropdown(item);
          });
        }

        if (filterDropdownType == 'number') {
          _this.setState({
            selectNumberValue: [item.key]
          }, function () {
            onSelectDropdown(item);
          });
        }
      }
    });

    _defineProperty(_assertThisInitialized(_this), "onClickClear", function () {
      var onClickClear = _this.props.onClickClear;

      if (onClickClear) {
        _this.setState({// selectValue: [],
          // selectNumberValue: []
        }, function () {
          onClickClear();
        });
      }
    });

    _defineProperty(_assertThisInitialized(_this), "getMenu", function () {
      var _this$state = _this.state,
          selectValue = _this$state.selectValue,
          selectNumberValue = _this$state.selectNumberValue;
      var _this$props2 = _this.props,
          filterDropdownType = _this$props2.filterDropdownType,
          filterDropdownIncludeKeys = _this$props2.filterDropdownIncludeKeys;
      var locale = getComponentLocale(_this.props, _this.context, 'Table', function () {
        return i18n;
      });
      var stringEnum = {
        LIKE: 'include',
        ULIKE: 'exclusive',
        EQ: 'equal',
        UEQ: 'unequal',
        START: 'begin',
        END: 'end'
      };
      var numberEnum = {
        GT: 'greater_than',
        GTEQ: 'great_than_equal_to',
        LT: 'less_than',
        LTEQ: 'less_than_equal_to',
        EQ: 'be_equal_to',
        UEQ: 'not_equal_to'
      };

      if (filterDropdownIncludeKeys != undefined) {
        switch (filterDropdownType) {
          case 'string':
            return /*#__PURE__*/React.createElement(Menu, {
              onClick: _this.onSelectDropdown,
              selectedKeys: selectValue
            }, filterDropdownIncludeKeys.map(function (item) {
              return /*#__PURE__*/React.createElement(Item, {
                key: item
              }, locale[stringEnum[item]]);
            }));

          case 'number':
            return /*#__PURE__*/React.createElement(Menu, {
              onClick: _this.onSelectDropdown,
              selectedKeys: selectNumberValue
            }, filterDropdownIncludeKeys.map(function (item) {
              return /*#__PURE__*/React.createElement(Item, {
                key: item
              }, locale[numberEnum[item]]);
            }));

          default:
            return /*#__PURE__*/React.createElement("div", null);
        }
      } else {
        switch (filterDropdownType) {
          case 'string':
            return /*#__PURE__*/React.createElement(Menu, {
              onClick: _this.onSelectDropdown,
              selectedKeys: selectValue
            }, /*#__PURE__*/React.createElement(Item, {
              key: "LIKE"
            }, locale['include']), /*#__PURE__*/React.createElement(Item, {
              key: "ULIKE"
            }, locale['exclusive']), /*#__PURE__*/React.createElement(Item, {
              key: "EQ"
            }, locale['equal']), /*#__PURE__*/React.createElement(Item, {
              key: "UEQ"
            }, locale['unequal']), /*#__PURE__*/React.createElement(Item, {
              key: "RLIKE"
            }, locale['begin']), /*#__PURE__*/React.createElement(Item, {
              key: "LLIKE"
            }, locale['end']));

          case 'number':
            return /*#__PURE__*/React.createElement(Menu, {
              onClick: _this.onSelectDropdown,
              selectedKeys: selectNumberValue
            }, /*#__PURE__*/React.createElement(Item, {
              key: "GT"
            }, locale['greater_than']), /*#__PURE__*/React.createElement(Item, {
              key: "GTEQ"
            }, locale['great_than_equal_to']), /*#__PURE__*/React.createElement(Item, {
              key: "LT"
            }, locale['less_than']), /*#__PURE__*/React.createElement(Item, {
              key: "LTEQ"
            }, locale['less_than_equal_to']), /*#__PURE__*/React.createElement(Item, {
              key: "EQ"
            }, locale['be_equal_to']), /*#__PURE__*/React.createElement(Item, {
              key: "UEQ"
            }, locale['not_equal_to']));

          default:
            return /*#__PURE__*/React.createElement("div", null);
        }
      }
    });

    _this.state = {
      selectValue: ['LIKE'],
      selectNumberValue: ['EQ']
    };
    return _this;
  }
  /**
   * 点击下拉菜单
   *
   * @param {*} s 选中的selectRecord
   */


  _createClass(FilterDropDown, [{
    key: "render",
    value: function render() {
      var isShowCondition = this.props.isShowCondition;
      return /*#__PURE__*/React.createElement("div", {
        className: "filter-btns"
      }, isShowCondition == 'show' && /*#__PURE__*/React.createElement(Dropdown, {
        overlayClassName: "".concat(prefix, "-filter-dropdown-menu-wrap"),
        trigger: ['click'],
        overlay: this.getMenu(),
        animation: "slide-up"
      }, /*#__PURE__*/React.createElement(Button, {
        shape: "border",
        style: {
          marginLeft: "2px",
          minWidth: "0px",
          width: "26px",
          lineHeight: "24px",
          padding: 0
        }
      }, /*#__PURE__*/React.createElement(Icon, {
        style: {
          padding: 0,
          color: '#585858'
        },
        type: "uf-filter"
      }))), /*#__PURE__*/React.createElement(Button, {
        onClick: this.onClickClear,
        shape: "border",
        style: {
          marginLeft: "2px",
          minWidth: "0px",
          width: "26px",
          lineHeight: "24px",
          padding: 0,
          "visibility": this.props.isShowClear || this.state.selectValue.length > 0 ? "visible" : "hidden"
        }
      }, /*#__PURE__*/React.createElement(Icon, {
        style: {
          padding: 0,
          color: '#585858',
          "visibility": this.props.isShowClear || this.state.selectValue.length > 0 ? "visible" : "hidden"
        },
        type: "uf-filterno"
      })));
    }
  }]);

  return FilterDropDown;
}(Component);

FilterDropDown.propTypes = {
  isShowCondition: PropTypes.string,
  filterDropdownType: PropTypes.oneOf(['string', 'number'])
};
FilterDropDown.defaultProps = {
  isShowCondition: 'show',
  filterDropdownType: 'string'
};
FilterDropDown.contextTypes = {
  beeLocale: PropTypes.object
};
export default FilterDropDown;


// WEBPACK FOOTER //
// ./~/@tinper/next-ui/lib/wui-table/src/FilterDropDown.js